export function getRange() {
  const selection = document.getSelection();
  if (selection == null) {
    console.log("No selection");
    return null;
  }
  return selection.getRangeAt(0);
}

export function getCursorOffsets(): { startOffset: number; endOffset: number } {
  const range = getRange();
  if (range == null) {
    console.log("No range");
    return { startOffset: 0, endOffset: 0 };
  }

  return {
    startOffset: getRangeStartOffset(range),
    endOffset: getRangeEndOffset(range)
  };
}

export function getRangeStartOffset(range: Range) {
  if (range.startOffset == 0) {
    return 0;
  }

  if (range.startContainer.nodeType != Node.TEXT_NODE) {
    // count all characters in previous child nodes
    let offset = 0;
    for (let i = 0; i < range.startOffset; i++) {
      const child = range.startContainer.childNodes[i];
      if (child.nodeType == Node.TEXT_NODE) {
        offset += (child as Text).length;
      } else {
        offset += (child as HTMLElement).innerText.length;
      }
    }
    return offset;
  } else if (range.startContainer.nodeType == Node.TEXT_NODE) {
    let offset = 0;
    const parentElement = range.startContainer.parentElement;
    if (parentElement) {
      // count all characters in previous child nodes
      const childNodes = parentElement.childNodes;
      for (const child of childNodes) {
        if (child == range.startContainer) {
          break;
        }
        if (child.nodeType == Node.TEXT_NODE) {
          offset += (child as Text).length;
        } else {
          offset += (child as HTMLElement).innerText.length;
        }
      }
    }
    return offset + range.startOffset;
  }
  return 0;
}

export function getRangeEndOffset(range: Range) {
  if (range.endOffset == 0) {
    return 0;
  }

  if (range.endContainer.nodeType != Node.TEXT_NODE) {
    // count all characters in previous child nodes
    let offset = 0;
    for (let i = 0; i < range.endOffset; i++) {
      const child = range.endContainer.childNodes[i];
      if (child.nodeType == Node.TEXT_NODE) {
        offset += (child as Text).length;
      } else {
        offset += (child as HTMLElement).innerText.length;
      }
    }
    return offset;
  } else if (range.endContainer.nodeType == Node.TEXT_NODE) {
    let offset = 0;
    const parentElement = range.endContainer.parentElement;
    if (parentElement) {
      // count all characters in previous child nodes
      const childNodes = parentElement.childNodes;
      for (const child of childNodes) {
        if (child == range.endContainer) {
          break;
        }
        if (child.nodeType == Node.TEXT_NODE) {
          offset += (child as Text).length;
        } else {
          offset += (child as HTMLElement).innerText.length;
        }
      }
    }
    return offset + range.endOffset;
  }
  return 0;
}
